// removed by extract-text-webpack-plugin
module.exports = {"container":"item-box__container___1KZGO","text":"item-box__text___3aNDr","small":"item-box__small___2IUOe","denominator":"item-box__denominator___2K-JP"};


//////////////////
// WEBPACK FOOTER
// ./src/scss/components/common/item-box.scss
// module id = 1308
// module chunks = 0